import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { ActivityExtra } from '../types/entities/ActivityExtra';
import { SetField } from '../components/Table/fields/SetField';
import { costType } from './costType';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPSetField } from '../components/Table/fields/SPSetField';

export const activityExtra: SchemaWithClient<ActivityExtra> = {
  name: 'Activity Extras',
  pluralName: 'Activity Extras',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    price: {
      name: 'Price',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    activity_cost_types: {
      name: 'Cost Types',
      fieldRenderer: SetField.tableAdapter(costType),
      slidePaneFieldRenderer: SPSetField.tableAdapter(costType),
      multiSwitchboard: true,
    },
    guide_commission: {
      name: 'Guide Commission',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/activity-extras'),
};
